import { render, staticRenderFns } from "./RelativeRelationTypeDelete.vue?vue&type=template&id=a10eef56&"
import script from "./RelativeRelationTypeDelete.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports